import { useAuthReady } from './useAuthReady';
import { useQuery } from '@tanstack/react-query';
import { fetchResolvedRecipient } from '../lib/recipients';
import type { Chain } from '../lib/transfers';

export function useResolveRecipient(tgUserId: string | null, chain: Chain) {
  const { canFetch, initData, cacheUserId: userId } = useAuthReady();
  const ready = canFetch && !!tgUserId;

  const query = useQuery({
    queryKey: ['resolvedRecipient', userId, chain, tgUserId ?? ''],
    enabled: ready,
    queryFn: () => fetchResolvedRecipient(initData, tgUserId!, chain),
    staleTime: 60_000,
    retry: false,
  });

  return {
    recipient: query.data ?? null,
    resolving: query.isFetching,
    failed: query.isError,
    noAddressForChain:
      query.error instanceof Error && query.error.message.includes('no_address_for_chain'),
  };
}
